import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  uploadImageToGoalRequest: ["id", "image"],
  uploadImageToGoalSuccess: ["goal"],
  uploadImageToGoalFailure: null,
});

export const UploadImageToGoalTypes = Types;
export const UploadImageToGoalActions = Creators;
export default Creators;

export const INITIAL_STATE = Immutable({
  id: null,
  image: null,
  fetching: null,
  success: null,
  error: null,
  goal: null,
});

export const UploadImageToGoalSelectors = {
  getData: (state: any) => state.uploadImageToGoal.data,
  isFetching: (state: any) => state.uploadImageToGoal.fetching,
  isSuccess: (state: any) => state.uploadImageToGoal.success,
  hasError: (state: any) => state.uploadImageToGoal.error,
};

export const request = (state: any, { id, image }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    id: id,
    image: image,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { goal } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    goal: goal,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    goal: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPLOAD_IMAGE_TO_GOAL_REQUEST]: request,
  [Types.UPLOAD_IMAGE_TO_GOAL_SUCCESS]: success,
  [Types.UPLOAD_IMAGE_TO_GOAL_FAILURE]: failure,
});
